(function(){
  /******VIDEO REVIEWS SLIDER*******/


  const instaSlider = new Swiper(".instFeed",{
    spaceBetween: 0,
    breakpoints: {
      320: {
        slidesPerView: 2.15
      },
      480: {
        slidesPerView: 2.15
      },
      750: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4.25
      },
      1440: {
        slidesPerView: 5.25
      }
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  })

  const videoReviewSlider = new Swiper(".video--review--slider",{
    spaceBetween: 17,
    breakpoints: {
      320: {
        slidesPerView: 2.15
      },
      480: {
        slidesPerView: 2
      },
      750: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4.25
      }
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  })

  /*****ICON WITH TEXT SLIDER FUNCTIONALITY****/

  const iconWithTextSlider= new Swiper(".icon-with-text-slider",{
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  })

  /******VIDEO PLAYING FUNCTIONALITY*****/

  const playTrigger = document.querySelectorAll("[playTrigger]");
  if(playTrigger.length > 0){
    playTrigger.forEach(function(e){
      e.addEventListener("click",function(){
        this.closest("[videoWrapper]").querySelector("video").play();
        this.classList.add("hidden");
      })
    })
  }

  const videoTriggers = document.querySelectorAll("[videoWrapper] video");
  if(videoTriggers.length > 0){
    videoTriggers.forEach(function(e){
      e.addEventListener("click",function(){
        if(!this.paused || !this.ended){
          this.pause();
          this.closest("[videoWrapper]").querySelector("[playTrigger]").classList.remove("hidden");
        }
      })
      e.addEventListener("ended",function(){
          this.closest("[videoWrapper]").querySelector("[playTrigger]").classList.remove("hidden");
          this.load();
      })
    })
  }
})();


$('.footer-nav__title').click(function(){
  if($(this).parents('.footer-nav').hasClass('active')){
    $('.footer-nav').removeClass('active');
  }else{
    $('.footer-nav').removeClass('active');
    $(this).parents('.footer-nav').addClass('active');
  }
});